import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
         
function Table(props) {
    const { tableColumns } = props

    // console.log("table props", props)

    const data = props.data ? props.data : []

    const dataTableProps = {
        loading: props.loading ? props.loading : false,

        showGridlines: props.showGridlines,
        rowsPerPageOptions: props.rowsPerPageOptions ? props.rowsPerPageOptions : [10, 20, 50],
        responsiveLayout: props.responsiveLayout ? props.responsiveLayout : "scroll",
        scrollable: props.scrollable ? props.scrollable : "true",
        scrollHeight: props.scrollHeight ? props.scrollHeight : "10px;",
        tableStyle: props.tableStyle ? props.tableStyle : null,
        tableClassName : props.tableClassName ? props.tableClassName : "",
        globalFilterFields: props.globalFilterFields ? props.globalFilterFields : ['name'],
        lazy: props.lazy,
        filterDisplay: props.filterDisplay ? props.filterDisplay : "menu",
        rowGroupMode: props.rowGroupMode ? props.rowGroupMode : null,
        groupRowsBy: props.groupRowsBy ? props.groupRowsBy : null,
        virtualScrollerOptions: props.virtualScrollerOptions || null
    }

    if(props.paginator){
        dataTableProps.paginator = true
        dataTableProps.rows = props.rows ? props.rows : 10
        dataTableProps.rowsPerPageOptions = props.rowsPerPageOptions ? props.rowsPerPageOptions : [10, 20, 50]
        dataTableProps.totalRecords = props.totalRecords ? props.totalRecords : 0
        dataTableProps.paginatorTemplate = props.paginatorTemplate ? props.paginatorTemplate : "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" 
        // dataTableProps.currentPageReportTemplate = props.currentPageReportTemplate ? props.currentPageReportTemplate : "Showing {first} to {last} of {totalRecords}"
        dataTableProps.currentPageReportTemplate = props.excessPagesFound ?  "Showing {first} to {last} of many" : "Showing {first} to {last} of {totalRecords}"
        dataTableProps.first = props.page * props.rows
    }

    if(props.filters){
        dataTableProps.filters = props.filters
        dataTableProps.sortField = props.sortField ? props.sortField : null
        dataTableProps.sortOrder = props.sortOrder ? props.sortOrder : null
        dataTableProps.onPage = props.onPage ? props.onPage : null
        dataTableProps.onSort = props.onSort ? props.onSort : null
        dataTableProps.onFilter = props.onFilter ? props.onFilter : null
    }

    return (
        <>
            <DataTable value={data} {...dataTableProps} 
                onPage={props.onPageChange}  
                rows={props.rows} 
                scrollable={props.scrollable} 
                scrollHeight={props.scrollHeight} 
                tableStyle={props.tableStyle} 
                tableClassName={props.tableClassName}
                paginator={props.paginator}
                rowClassName={props.rowClassName}
                rowGroupMode={props.rowGroupMode}
                groupRowsBy={props.groupRowsBy}
                sortMode={props.sortMode} 
                sortOrder={props.sortOrder}
                sortField={props.sortField}
            >
                {
                    tableColumns?.map(column => {
                        return <Column key={column.header} showFilterMenu={false} showFilterOperator={false} showAddButton={false} {...column}></Column>
                    })
                }
            </DataTable>
        </>
    );
}

export default Table;